var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/login"}}),_c('router-link',{attrs:{"to":"/"}}),_c('router-link',{attrs:{"to":"/addadmin"}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }